<template>
<section id="seccion4" class="wrapper">
        <section class="main">

            <article class="forma">
                <h2>THE MOST SUITABLE TEST TO LEVEL IS: </h2>
                <h1>Top Level English</h1>
                    <p>
                        <img src="@\assets\Captura.png" width="900">
                        Cambridge University certificates are valid for life, so they are suitable for those who want to have an official document certifying their level without expiration. Of academic character and with great recognition, they are ideal to give international solidity to your Curriculum Vitae.
                        <br>
                        <br>
                        Los certificados de la Universidad de Cambridge son válidos de por vida, por lo que son los adecuados para aquellos que quieren tener un documento oficial que certifica su nivel sin caducidad. De carácter académico y con gran reconocimiento, son ideales para darle solidez internacional a tu Currículum Vitae. 
                    </p>
            </article>
            
            <nav class="fila" id="fila">
                <ul>
                
                    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
                    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
                    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
                    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
                    <li class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><a href="https://www.cambridgeenglish.org/exams-and-tests/qualifications/">INGRESO</a></li>
                    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
                </ul>
            </nav>
            
    </section>

    <section id="seccion4" class="wrapper">
    <article class="forma">
        <p>
            <img src="@\assets\logo-de-toefl.jpg" width="900">
            TOEFL IBT (Internet Based TOEFL), carried out on a computer via the internet, always from an accredited exam center. Most of the tests are carried out today in this format. The maximum score that can be obtained is 120 points.
            <br>
            <br>
            TOEFL IBT (Internet Based TOEFL), realizado en un ordenador a través de internet, siempre desde un centro examinador acreditado. La mayoría de tests son realizados a día de hoy en este formato. La puntuación máxima que se puede obtener son 120 puntos.
        </p>
    </article>

    <nav class="fila" id="fila">
    <ul>
        <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
        <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
        <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
        <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
        <li class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><a href="https://www.ets.org/s/cv/toefl/at-home/">INGRESO</a></li>
        <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
    </ul>
    </nav>
    
</section>

<article class="forma">
    <p>
        <img src= "@\assets\logo-ielts-test-centre.png" width="700">
        IELTS; This test is managed by the University of Cambridge, the British Council and IDP Education Australia. This is the exam you should take if you are thinking of studying at a British, Australian, New Zealand or any other part of the world that accepts it. It is accepted even in many American universities, which historically have always preferred the TOEFL. Like this one, it is valid for two years.
        <br>
        <br>
        IELTS; Esta prueba está gestionada por la Universidad de Cambridge, el British Council y IDP Education Australia. Este es el examen que debes hacer si estás pensando en estudiar en una universidad británica, australiana, neozelandesa o de cualquier otra parte del mundo que lo acepte. Es acpetado incluso en muchas universidades americanas, que históricamente siempre han preferido el TOEFL. Al igual que éste, tiene una validez de dos años. 
    </p>
</article>

<nav class="fila" id="fila">
<ul>

    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
    <li class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><a href="https://www.ielts.org/for-test-takers/book-a-test">INGRESO</a></li>
    <li class="col-lg-2 col-md-2 col-sm-2 col-xs-0"><a href="#"></a></li>
</ul>
</nav>
      <!--Section heading-->
      <br>
      <br>
      <br>
      <h2 class="h1-responsive font-weight-bold text-center my-4">Contact us!</h2>
      <!--Section description-->
      <p class="text-center w-responsive mx-auto mb-5"> We would love to hear from you!</p>
      <div class="row">

        <!--Grid column-->
        <div class="col-md-9 mb-md-0 mb-5">
          <form id="contact-form" name="contact-form" action="mail.php" method="POST">

            <!--Grid row-->
            <div class="row p-3">

              <!--Grid column-->
              <div class="col-md-6">
                <div class="md-form mb-0">
                  <input type="text" id="name" name="name" class="form-control">
                  <label for="name" class="">Name</label>
                </div>
              </div>
              <!--Grid column-->

              <!--Grid column-->
              <div class="col-md-6">
                <div class="md-form mb-0">
                  <input type="text" id="email" name="email" class="form-control">
                  <label for="email" class="">E-mail</label>
                </div>
              </div>
              <!--Grid column-->

            </div>
            <!--Grid row-->

            <!--Grid row-->
            <div class="row p-3">
              <div class="col-md-12">
                <div class="md-form mb-0">
                  <input type="text" id="subject" name="subject" class="form-control">
                  <label for="subject" class="">Subject</label>
                </div>
              </div>
            </div>
            <!--Grid row-->

            <!--Grid row-->
            <div class="row p-3">

              <!--Grid column-->
              <div class="col-md-12">

                <div class="md-form">
                  <textarea id="message" name="message" rows="2" class="form-control md-textarea"></textarea>
                  <label for="message">Message</label>
                </div>

              </div>
            </div>
            <!--Grid row-->

          </form>

          <div class="text-center text-md-left">
            <a class="btn btn-primary" onclick="document.getElementById('contact-form').submit();">Send</a>
          </div>
          <div class="status"></div>
        </div>
        <!--Grid column-->

      </div>

</section>
</template>

<style src="../assets/css/Style.css"></style>
<style src="../assets/css/index.css"></style>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  beforeCreate(){
    var autenticacion = window.localStorage.getItem('autenticacion');
    if (autenticacion !== 'ok'){
      this.$router.push({path: "/Login"});
    }
  },
  components: {
  
  }
}
</script>
